import loadable from "@loadable/component";
import StatusIcon from "../../Icons/StatusIcon";

const CityListComponent = loadable(
  () => import("../../components/City/CityList")
);

const CityList = () => {
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <StatusIcon />
        <span className="text-[#5E5757] font-bold text-xl">City</span>
      </div>
      <CityListComponent />
    </>
  );
};



export default CityList
